export const availableRoom = ({ accountType, config, year, unusedRoom, income }) => {
  const limits = config.yearly_limits;
  const defaultLimit = limits[Math.max(...Object.keys(limits).map(Number))];
  const limit = limits[year] || defaultLimit;

  if (accountType === "fhsa") {
    return Math.min(limit + Math.min(unusedRoom, 8000), config.lifetime_cap || 40000);
  }

  if (accountType === "rrsp") {
    return Math.min(income * 0.18, limit) + unusedRoom;
  }

  return limit + unusedRoom;
};

export const projectValue = (annualContribution, annualReturn, years) => {
  let total = 0;
  for (let index = 0; index < years; index += 1) {
    total = (total + annualContribution) * (1 + (annualReturn / 100));
  }
  return total;
};

export const compareScenarios = ({ room, monthly, years, annualReturn }) => {
  const base = monthly * 12;
  const scenarios = [
    { name: "Steady", annual: base },
    { name: "Catch-up", annual: Math.min(base * 1.5, room) },
    { name: "Max Room", annual: room }
  ];

  return scenarios.map((scenario) => ({
    ...scenario,
    contributed: scenario.annual * years,
    projected: projectValue(scenario.annual, annualReturn, years)
  }));
};

export const initContributionPlannerPage = () => {
  const root = document.querySelector("[data-planner-account]");
  if (!root) return;

  const config = JSON.parse(root.dataset.plannerConfig);
  const accountType = root.dataset.plannerAccount;
  const ids = ["year", "unusedRoom", "income", "monthly", "years", "annualReturn"];
  const fields = Object.fromEntries(ids.map((id) => [id, document.getElementById(id)]));
  const results = document.getElementById("results");
  const roomValue = document.getElementById("roomValue");
  const rows = document.getElementById("scenarioRows");
  const carrySummary = document.getElementById("carrySummary");
  const shareUrl = document.getElementById("shareUrl");

  const fmt = (value) => new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    maximumFractionDigits: 0
  }).format(value);

  const getInput = () => ({
    year: Number(fields.year.value),
    unusedRoom: Number(fields.unusedRoom.value),
    income: Number(fields.income.value),
    monthly: Number(fields.monthly.value),
    years: Number(fields.years.value),
    annualReturn: Number(fields.annualReturn.value)
  });

  const updateShareUrl = (data) => {
    const url = new URL(window.location.href);
    Object.entries(data).forEach(([key, value]) => url.searchParams.set(key, String(value)));
    shareUrl.value = url.toString();
    window.history.replaceState({}, "", `${url.pathname}?${url.searchParams.toString()}`);
  };

  const hydrateFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    ids.forEach((id) => {
      if (params.has(id)) fields[id].value = params.get(id);
    });
  };

  const render = () => {
    const data = getInput();
    const room = availableRoom({ accountType, config, ...data });
    const scenarios = compareScenarios({ room, ...data });

    roomValue.textContent = fmt(room);
    carrySummary.textContent = accountType === "fhsa"
      ? "Up to $8,000 carry-forward usable each year."
      : "Unused room is assumed to carry forward in full.";

    rows.innerHTML = scenarios
      .map((scenario) => `<tr><td>${scenario.name}</td><td>${fmt(scenario.annual)}</td><td>${fmt(scenario.contributed)}</td><td>${fmt(scenario.projected)}</td></tr>`)
      .join("");
    results.classList.add("show");
    updateShareUrl(data);
  };

  hydrateFromUrl();
  document.getElementById("runPlanner").addEventListener("click", render);
  document.getElementById("copyShare").addEventListener("click", async () => {
    if (!shareUrl.value) return;
    try {
      await navigator.clipboard.writeText(shareUrl.value);
    } catch (_) {}
  });
};
